const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  LECTURER: 'lecturer',
  STUDENT: 'student',
};

export default ROLES;
